module.exports = __webpack_public_path__ + "img/retextoar-app.e1b0fb59.png";